import FormattedRelativeTime from "./Format/FormattedRelativeTime";

type Props = {
  date: $TSFixMe; // TODO: PropTypes.instanceOf(Date)
  id?: string;
  infoPopup?: React.ReactNode;
  hoursAfterLatestUpdateToExpire?: number;
};

function ExpirableDate({
  date,
  id,
  infoPopup,
  hoursAfterLatestUpdateToExpire,
}: Props) {
  const isDateOlderThanOneDay =
    // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
    new Date() - date > hoursAfterLatestUpdateToExpire * 60 * 60 * 1000;
  return (
    <div data-testid="expirable-date" className="expirable-date">
      <FormattedRelativeTime
        // @ts-expect-error TS(2322) FIXME: Type '{ id: string | undefined; customClass: strin... Remove this comment to see the full error message
        id={id}
        customClass={isDateOlderThanOneDay ? "offline" : ""}
        value={date}
      />
      {isDateOlderThanOneDay ? infoPopup : null}
    </div>
  );
}

export default ExpirableDate;
